
<div class="container" mat-dialog-content>
  
  <div (click)="select(item)" class="line-item" *ngFor="let item of prefillLineItems">
    <div class="item">{{item.item}}</div>
    <div class="desc">{{item.desc}}</div>
    <div class="price">{{item.price | human}}</div>
  </div>

</div>
  
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>Close</button>
</div>
  